import React from "react"
import { Link } from "react-router-dom"
import {
  Container,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// import images
import img1 from "../../assets/images/small/img-2.jpg"
import avtar1 from "../../assets/images/users/avatar-2.jpg"
import { FaWhatsapp } from "react-icons/fa"

const BlogDetails = () => {
  //meta title
  document.title = "Blog Details | Aiinrealestate";

  const phoneNumber = "+919586363303";

  // Function to generate the WhatsApp URL with the current page URL
  const generateWhatsAppLink = () => {
    const currentPageURL = window.location.href; // Get the current page URL
    const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <Breadcrumbs title="Blog" breadcrumbItem="Blog Details" /> */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody style={{ backgroundColor: '#1E253A', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 10px rgba(0,0,0,0.3)' }}>
                  <div className="pt-3">
                    <div className="row justify-content-center">
                      <div className="col-xl-8">
                        <div>
                          <div className="text-center text-light">
                            {/* <div className="mb-4">
                              <Link
                                to="#"
                                className="badge bg-light font-size-12"
                              >
                                <i className="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>{" "}
                                Project
                              </Link>
                            </div> */}
                            <h4>Understanding Jantri: Gujarat's Land and Property Valuation System</h4>
                            <p className="text-light mb-2">
                              <i className="mdi mdi-calendar me-1"></i> 15 Apr, 2025
                            </p>
                          </div>

                          <hr />
                          <div className="text-center">
                            <Row>
                              <Col sm={6}>
                                <div>
                                  <p className="text-light mb-2">Categories</p>
                                  <h5 className="font-size-15 text-light">Jantri</h5>
                                </div>
                              </Col>
                              {/* <Col sm={4}>
                                <div className="mt-4 mt-sm-0">
                                  <p className="text-muted mb-2">Date</p>
                                  <h5 className="font-size-15">15 Apr, 2025</h5>
                                </div>
                              </Col> */}
                              <Col sm={6}>
                                <div className="mt-4 mt-sm-0 text-light">
                                  <p className=" mb-2">Post by</p>
                                  <h5 className="font-size-15">Vivek</h5>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <hr />

                          <div className="my-2">
                            <img
                              src={img1}
                              alt=""
                              className="img-thumbnail mx-auto d-block"
                            />
                          </div>

                          <hr />

                          <div className="mt-4 text-light">
                            <div className=" font-size-14">
                              <p>
                                The term Jantri originates from the Gujarati language and refers to the government-mandated minimum value of land and property in Gujarat, India. Officially known as the Annual Statement of Rates (ASR), the Jantri system plays a significant role in determining property transaction costs, particularly stamp duty and registration fees.
                              </p>

                              <p className="mb-4">
                                <h5 className="mb-3">What is Jantri? </h5>

                                Jantri serves as a benchmark for property transactions in Gujarat. It sets the minimum value for land and property, ensuring uniformity and transparency in the real estate market. The government periodically updates the Jantri rate to reflect the current market conditions and trends. These rates are publicly available on the Gujarat government’s official website.
                              </p>

                              <blockquote className="p-4 border-light border rounded mb-4">
                                <div className="d-flex">
                                  <div className="me-3">
                                    <i className="bx bxs-quote-alt-left text-dark font-size-24"></i>
                                  </div>
                                  <div>
                                    <p className="mb-0">
                                      {" "}
                                      The Jantri system ensures transparency in Gujarat's property transactions, providing both buyers and sellers a clear framework for fair valuation and associated costs.
                                    </p>
                                  </div>
                                </div>
                              </blockquote>

                              {/* <p>
                                <h5 className="mb-3">How Does the Jantri Rate Affect Property Prices? </h5>
                                The Jantri rate system operates as follows:

                                Setting Minimum Values: The Jantri rate establishes a baseline value for property transactions, below which properties cannot be registered.

                                Calculating Stamp Duty and Registration Fees:

                                Stamp duty and registration fees are calculated based on either the Jantri rate or the market value of the property, whichever is higher.

                                Periodic Updates: The Gujarat government revises Jantri rates periodically to align with market dynamics.
                              </p> */}

                              <div className="mt-4">
                                <h5 className="mb-3">How Does the Jantri Rate Affect Property Prices?: </h5>

                                <div>
                                  <div className="row">
                                    <div className="col-lg-6 col-sm-6">
                                      <div>
                                        <ul className="ps-4">
                                          <li className="py-1">
                                            Buyers can use the Jantri rate to estimate and plan for additional costs, such as stamp duty and registration fees, when budgeting for a property purchase.
                                          </li>
                                          {/* <li className="py-1">
                                            Sed consequat leo eget
                                          </li>
                                          <li className="py-1">
                                            Aliquam lorem ante
                                          </li> */}
                                        </ul>
                                      </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                      <div>
                                        <ul className="ps-4">
                                          <li className="py-1">
                                            Sellers can reference the Jantri rate to determine a fair price for their property and ensure compliance with government regulations.
                                          </li>
                                          {/* <li className="py-1">
                                            Cum sociis natoque
                                          </li> */}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <p className="mb-4">
                                <h5 className="mb-3">Conclusion: </h5>

                                The Jantri rate system is a vital tool in Gujarat’s real estate landscape. By standardizing the minimum value of property transactions, it ensures transparency and fairness while aiding in the calculation of associated costs like stamp duty and registration fees. Whether you are a buyer or a seller, understanding the Jantri rate system is essential for navigating Gujarat’s property market efficiently. For the most accurate and updated information, you can access the Jantri rates on the Gujarat government’s official website.
                              </p>
                            </div>

                            <hr />
                            {/* 
                            <div className="mt-5">
                              <h5 className="font-size-15">
                                <i className="bx bx-message-dots text-muted align-middle me-1"></i>{" "}
                                Comments :
                              </h5>

                              <div>
                                <div className="d-flex py-3">
                                  <div className="avatar-xs me-3">
                                    <div className="avatar-title rounded-circle bg-light text-primary">
                                      <i className="bx bxs-user"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-1">
                                      Delores Williams{" "}
                                      <small className="text-muted float-end">
                                        1 hr Ago
                                      </small>
                                    </h5>
                                    <p className="text-muted">
                                      If several languages coalesce, the grammar of
                                      the resulting language is more simple and
                                      regular than that of the individual
                                    </p>
                                    <div>
                                      <Link to="#" className="text-success">
                                        <i className="mdi mdi-reply"></i> Reply
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex py-3 border-top">
                                  <div className="avatar-xs me-3">
                                    <img
                                      src={avtar1}
                                      alt=""
                                      className="img-fluid d-block rounded-circle"
                                    />
                                  </div>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-1">
                                      Clarence Smith{" "}
                                      <small className="text-muted float-end">
                                        2 hrs Ago
                                      </small>
                                    </h5>
                                    <p className="text-muted">
                                      Neque porro quisquam est, qui dolorem ipsum
                                      quia dolor sit amet
                                    </p>
                                    <div>
                                      <Link to="#" className="text-success">
                                        <i className="mdi mdi-reply"></i> Reply
                                      </Link>
                                    </div>

                                    <div className="d-flex pt-3">
                                      <div className="avatar-xs me-3">
                                        <div className="avatar-title rounded-circle bg-light text-primary">
                                          <i className="bx bxs-user"></i>
                                        </div>
                                      </div>
                                      <div className="flex-grow-1">
                                        <h5 className="font-size-14 mb-1">
                                          Silvia Martinez{" "}
                                          <small className="text-muted float-end">
                                            2 hrs Ago
                                          </small>
                                        </h5>
                                        <p className="text-muted">
                                          To take a trivial example, which of us
                                          ever undertakes laborious physical
                                          exercise
                                        </p>
                                        <div>
                                          <Link to="#" className="text-success">
                                            <i className="mdi mdi-reply"></i> Reply
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex py-3 border-top">
                                  <div className="avatar-xs me-3">
                                    <div className="avatar-title rounded-circle bg-light text-primary">
                                      <i className="bx bxs-user"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-1">
                                      Keith McCoy{" "}
                                      <small className="text-muted float-end">
                                        12 Aug
                                      </small>
                                    </h5>
                                    <p className="text-muted">
                                      Donec posuere vulputate arcu. phasellus
                                      accumsan cursus velit
                                    </p>
                                    <div>
                                      <Link to="#" className="text-success">
                                        <i className="mdi mdi-reply"></i> Reply
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> */}

                            <div className="mt-4">
                              <h5 className="font-size-16 mb-3">Leave a Message</h5>

                              <Form>
                                <Row>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="commentname-input">
                                        Name
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="commentname-input"
                                        placeholder="Enter name"
                                      />
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="commentemail-input">
                                        Email
                                      </Label>
                                      <input
                                        type="email"
                                        className="form-control"
                                        id="commentemail-input"
                                        placeholder="Enter email"
                                      />
                                    </div>
                                  </Col>
                                </Row>

                                <div className="mb-3">
                                  <Label htmlFor="commentmessage-input">
                                    Message
                                  </Label>
                                  <textarea
                                    className="form-control"
                                    id="commentmessage-input"
                                    placeholder="Your message..."
                                    rows="3"
                                  ></textarea>
                                </div>

                                <div className="text-end">
                                  <button
                                    type="submit"
                                    className="btn btn-success w-sm"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
                <div
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    zIndex: 1000,
                  }}
                >
                  {/* Icons Container */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "12px",
                      gap: "10px", // Reduced gap for a more compact design
                    }}
                  >
                    {/* WhatsApp Icon */}
                    <a
                      href={generateWhatsAppLink()}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "white",
                        fontSize: "1.2rem", // Reduced font size
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "40px", // Reduced icon size
                        height: "40px",
                        background: "linear-gradient(135deg, #1FAF51, #25D366)", // Slightly adjusted green gradient
                        borderRadius: "50%",
                        boxShadow: "0px 3px 10px rgba(31, 175, 81, 0.6)",
                        transition: "all 0.3s ease",
                      }}
                      title="Chat on WhatsApp"
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.1)";
                        e.target.style.boxShadow = "0px 5px 15px rgba(31, 175, 81, 0.8)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                        e.target.style.boxShadow = "0px 3px 10px rgba(31, 175, 81, 0.6)";
                      }}
                    >
                      <FaWhatsapp />
                    </a>

                    {/* Call Icon */}
                    <a
                      href="tel:+919586363303"
                      style={{
                        color: "white",
                        fontSize: "1.2rem", // Reduced font size
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "40px", // Reduced icon size
                        height: "40px",
                        background: "linear-gradient(135deg, #1E90FF, #34B7F1)", // Slightly adjusted blue gradient
                        borderRadius: "50%",
                        boxShadow: "0px 3px 10px rgba(30, 144, 255, 0.6)",
                        transition: "all 0.3s ease",
                      }}
                      title="Call Us"
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.1)";
                        e.target.style.boxShadow = "0px 5px 15px rgba(30, 144, 255, 0.8)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                        e.target.style.boxShadow = "0px 3px 10px rgba(30, 144, 255, 0.6)";
                      }}
                    >
                      <i className="fas fa-phone" />
                    </a>
                  </div>

                  {/* Query Button */}
                  <Link
                    to="/dashboard"
                    title="Any Questions or Queries?"
                    style={{
                      background: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient effect for the button
                      border: "none",
                      borderRadius: "9999px",
                      padding: "10px 20px", // Adjusted padding
                      fontSize: "14px", // Reduced font size
                      color: "white",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.1)";
                      e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                      e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.3)";
                    }}
                  >
                    Ask Ai &nbsp; <i className="fas fa-question" style={{ margin: 0 }}></i>
                  </Link>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BlogDetails
